import { useEffect } from "react";

export default function useWebReportMeta(title) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} | ChampionBred`;
    const restore = [
      ["robots", "noindex, nofollow"],
      ["referrer", "no-referrer"],
    ].map(([name, content]) => {
      const existing = document.querySelector(`meta[name="${name}"]`);
      const meta = existing || document.createElement("meta");
      const previous = meta.getAttribute("content");
      meta.name = name;
      meta.content = content;
      if (!existing) document.head.appendChild(meta);
      return () => {
        if (existing) meta.setAttribute("content", previous || "");
        else meta.remove();
      };
    });
    return () => {
      document.title = previousTitle;
      restore.forEach((callback) => callback());
    };
  }, [title]);
}
